
$(document).ready(function(){
  // $('.hero.hero--video-background').on('click',function(){
  //   const parent = $(this).parent();
  //   const url = $('.hero__button',parent).attr('href');
  //   location.href = url;
  // });  
  
  $('.romanoff-cross-sell-slider').each(function(){
    const slidesToShow = parseInt($(this).data('slides-to-show')) || 5;

    if (slidesToShow == 1) {
      $(this).slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '0px',
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        responsive: [          
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    } else {
      $(this).slick({
        slidesToScroll: 1,
        centerPadding: '0px',
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: false,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });

  // Initial active thumb
  $('.romanoff-thumb').first().addClass('active');

  // Click to swap image
  $('.romanoff-thumb').on('click', function() {
    var newSrc = $(this).data('image');
    var mainImage = $('#romanoff-main-image');

    // Active state
    $('.romanoff-thumb').removeClass('active');
    $(this).addClass('active');

    // Fade animation
    mainImage.addClass('fade-out');

    setTimeout(function() {
      mainImage.attr('src', newSrc);
      mainImage.removeClass('fade-out').addClass('fade-in');

      setTimeout(function() {
        mainImage.removeClass('fade-in');
      }, 300);

    }, 200);
  });

  // OPTIONAL: Variant image syncing
  // Works if variant has featured_media.id
  $('select[name="id"]').on('change', function() {
    var selectedVariant = $(this).find('option:selected');
    var mediaId = selectedVariant.data('media-id');

    if (mediaId) {
      var targetThumb = $('.romanoff-thumb[data-image-id="' + mediaId + '"]');
      if (targetThumb.length) {
        targetThumb.trigger('click');
      }
    }
  });

  // Prevent theme scripts from triggering the click
  $('#romanoff-main-image').off('click.romanoff');

  // OPEN LIGHTBOX
  $('#romanoff-main-image').on('click.romanoff', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var src = $(this).attr('src');

    $('#romanoff-lightbox-img')
      .attr('src', src)
      .css('opacity', 0);

    // Disable page scroll
    $('body').css('overflow', 'hidden');

    $('#romanoff-lightbox').fadeIn(200, function() {
      $('#romanoff-lightbox-img').css('opacity', 1);
    });
  });

  // CLOSE LIGHTBOX
  function romanoffCloseLightbox() {
    $('#romanoff-lightbox').fadeOut(200);
    $('body').css('overflow', ''); // Restore scroll
  }

  $('.romanoff-lightbox-close').on('click', romanoffCloseLightbox);

  $('#romanoff-lightbox').on('click', function(e) {
    if (e.target === this) romanoffCloseLightbox();
  });

  $(document).on('keyup', function(e) {
    if (e.key === "Escape") romanoffCloseLightbox();
  });

  $('collapsible-section').each(function() {
    var $section = $(this);
    var $target = $section.find('.wt-collapse__target--text.rte');

    // Check if empty (ignores whitespace)
    // if ($.trim($target.html()) === '') {
    //   $section.hide();
    //   $section.next().hide(); // hide next sibling
    // }
  });



  const $modal = $('#quote-modal');
  const $titleField = $('#quote-product-title');
  const $success = $('#quote-success');

  // Open modal + populate fields
  $(document).on('click', '.request-quote-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const productTitle = $(this).data('product-title');

    $titleField.val(productTitle);
    $success.hide();
    $('#quote-form')[0].reset();
    $titleField.val(productTitle);

    $modal.addClass('open');
  });

  // Close modal
  $('.quote-modal-close').on('click', function() {
    $modal.removeClass('open');
  });

  // Close when clicking outside modal
  $(window).on('click', function(e) {
    if ($(e.target).is('#quote-modal')) {
      $modal.removeClass('open');
    }
  });

  $('#quote-form').on('submit', function(e) {
    e.preventDefault();

    var form = $(this)[0];
    var formData = new FormData(form);

    // Debug: print all fields
    for (var pair of formData.entries()) {
      console.log(pair[0]+ ': ' + pair[1]);
    }

    $.ajax({
      url: '/contact',
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: function() {
        $('#quote-success').fadeIn();
        $('#quote-form')[0].reset();
      },
      error: function(err) {
        console.error("Contact form error:", err);
      }
    });

  });
});

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.romanoff-mega-menu__trigger');
  const wrapper = document.querySelector('.romanoff-mega-menu__wrapper');

  if (!trigger) {
    wrapper.querySelectorAll('.romanoff-mega-menu__panel').forEach(panel => {
      panel.classList.remove('open');
    });
    wrapper.querySelectorAll('.romanoff-mega-menu__trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
    });
    return;
  }

  const panel = document.getElementById(`panel-${trigger.dataset.menu}`);
  const subpanel = document.getElementById(`subpanel-${trigger.dataset.menu}`);
  const isOpen = panel.classList.contains('open');

  wrapper.querySelectorAll('.romanoff-mega-menu__panel').forEach(p => p.classList.remove('open'));
  wrapper.querySelectorAll('.romanoff-mega-menu__trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));

  if (!isOpen) {
    panel.classList.add('open');
    subpanel.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
  }
});

// Build Breadcrum
document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname;
  const menuRoot = document.querySelector(".romanoff-mega-menu__wrapper");
  if (!menuRoot) return;

  let lookupUrl = currentPath;

  // PRODUCT PAGE LOGIC
  const colEl = document.querySelector("#breadcrumb-collections");
  if (colEl) {
    const colList = JSON.parse(colEl.getAttribute("data-collections"));
    for (const colUrl of colList) {
      const match = menuRoot.querySelector(`a[href="${colUrl}"]`);
      if (match) lookupUrl = colUrl;
    }
  }

  const activeLink = menuRoot.querySelector(`a[href="${lookupUrl}"]`);
  if (!activeLink) return;

  const breadcrumb = [];

  // 1. Home
  breadcrumb.push({ title: "Home", url: "/" });

  // 2. Current page
  breadcrumb.push({
    title: activeLink.textContent.trim(),
    url: activeLink.getAttribute("href")
  });

  // Detect current level
  const currentWrapper = activeLink.closest(".romanoff-mega-menu__link-wrapper");
  const levelMatch = currentWrapper && currentWrapper.className.match(/level-(\d+)/);
  const currentLevel = levelMatch ? parseInt(levelMatch[1], 10) : null;

  // 3. Level 3 (only when current is level 4)
  if (currentLevel >= 4) {
    const parentSublist = activeLink.closest(".romanoff-mega-menu__sublist.level-3");
    if (parentSublist) {
      const parentItem = parentSublist.closest(".romanoff-mega-menu__item");
      if (parentItem) {
        const level3Link = parentItem.querySelector(".romanoff-mega-menu__link-wrapper.level-3 a");
        if (level3Link) {
          breadcrumb.push({
            title: level3Link.textContent.trim(),
            url: level3Link.getAttribute("href")
          });
        }
      }
    }
  }

  // 4. Level 2 (only when current level >= 3)
  if (currentLevel >= 3) {
    const column = activeLink.closest(".romanoff-mega-menu__column");
    if (column) {
      const level2Link = column.querySelector(".romanoff-mega-menu__link-wrapper.level-2 a");
      if (level2Link) {
        breadcrumb.push({
          title: level2Link.textContent.trim(),
          url: level2Link.getAttribute("href")
        });
      }
    }
  }

  // 5. Level 1 (trigger)
  const panel = activeLink.closest(".romanoff-mega-menu__panel");
  if (panel) {
    const panelId = panel.id.replace("panel-", "");
    const level1Trigger = menuRoot.querySelector(
      `.romanoff-mega-menu__trigger[data-menu="${panelId}"]`
    );

    if (level1Trigger) {
      breadcrumb.push({
        title: level1Trigger.childNodes[0].textContent.trim(),
        url: "/" + panelId
      });
    }
  }

  // 6. Reverse everything except Home
  const home = breadcrumb.shift();
  breadcrumb.reverse();
  breadcrumb.unshift(home);

  // Render
  const container = document.querySelector(".breadcrumb");
  if (container) {
    container.innerHTML = breadcrumb
      .map(item => `<a href="${item.url}">${item.title}</a>`)
      .join(" › ");
  }
});



$(window).on('load', function(){
  $('.romanoff-cross-sell-slider').slick('setPosition');

});
